import React from 'react';
import { Icon } from './Icon.js';
export const IconAlertQuestion = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("circle", { cx: "10", cy: "15.5", r: "1.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m7.358,6.107c.368-1.506,1.501-2.107,3.079-2.107,1.362,0,2.567.817,2.567,2.553,0,2.444-3.01,2.025-3.01,4.947", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconAlertQuestion.js.map